"use client";

import { CharityDonateTiers } from "@/components/home/cards/CharityDonateTiers";
import { DonateGoldCta } from "@/components/donate/DonateGoldCta";
import { DonateImageBackdrop } from "@/components/donate/DonateImageBackdrop";
import { Reveal } from "@/components/motion/Reveal";
import type { HomeDonateSection } from "@/lib/api-types";
import { DEFAULT_HOME_DONATE } from "@/lib/site-content-fallbacks";

type HomeDonateAndAboutProps = {
  donate?: HomeDonateSection;
};

export function HomeDonateAndAbout({
  donate = DEFAULT_HOME_DONATE,
}: HomeDonateAndAboutProps) {
  return (
    <DonateImageBackdrop
      className="home-donate-banner"
      minHeight="min-h-[520px] md:min-h-[560px]"
      contentClassName="max-w-3xl"
    >
      <div className="relative">
        <Reveal>
          <h2 className="font-display text-3xl font-bold text-white md:text-4xl">
            {donate.title}
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-white/85 md:text-base">
            {donate.subtitle}
          </p>
        </Reveal>

        <Reveal delay={0.08}>
          <div className="mt-8">
            <CharityDonateTiers variant="dark" />
          </div>
        </Reveal>

        <Reveal delay={0.14}>
          <div className="mt-8">
            <DonateGoldCta href={donate.ctaHref} label={donate.cta} />
          </div>
        </Reveal>
      </div>
    </DonateImageBackdrop>
  );
}
